import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import _ from "lodash"
import ApplicationCard from "./ApplicationCard"
import { getApplications, setAppCode } from "../../appRedux/slices/application"
import "./dashboard.css"
import Auxiliary from "../../util/Auxiliary"
import { withRouter } from "react-router-dom"

const ApplicationList = props => {
  const dispatch = useDispatch()

  const { data: { applications = [] } = {} } = props?.currentUser || {}

  const appCodes = applications.map(application => application.applicationCode)

  const {
    loading = false,
    applicationList = [],
    common,
    refetchApplicationList = false,
  } = useSelector(state => ({
    loading: _.get(state, "application.loading") || false,
    applicationList: _.get(state, "application.applicationList") || [],
    refetchApplicationList:
      _.get(state, "application.refetchApplicationList") || false,
    common: _.get(state, "common"),
  }))

  useEffect(() => {
    const email = props?.currentUser?.data?.email
    const appPayload = {
      appCodes,
      email,
    }
    dispatch(getApplications({ appPayload }))
  }, [dispatch, refetchApplicationList])

  const _goToUserPage = application => {
    dispatch(setAppCode({ appCode: application.appCode }))
    if (!_.isEmpty(application.appCode)) {
      sessionStorage.setItem("appCode", application.appCode)
    }
    if (!_.isEmpty(application.appName)) {
      sessionStorage.setItem("appName", application.appName)
    }
    props.history.push(`/user/browse?appCode=${application.appCode}`)
  }

  return (
    <>
      <Auxiliary
        cssClassName="dashboard_loading"
        loading={loading}
        error={common.error}
      >
        {applicationList.map((application, idx) => {
          if (application && application.status === true) {
            return (
              <div className="card-size" key={application.appCode}>
                <ApplicationCard
                  application={application}
                  key={`${loading}_${idx}`}
                  onEdit={props.onAppEdit}
                  goToUserPage={_goToUserPage}
                />
              </div>
            )
          }
        })}
      </Auxiliary>
    </>
  )
}

export default withRouter(ApplicationList)
